<template>
  <div class="macroscopic">
    <div class="head">
      <i></i>
      <p>政策法规</p>
      <span class="fr" @click="toTwoPage('/macroscopic/twoPage/industry', queryParams['sourceType'])">更多 ></span>
    </div>
    <div class="banner">
      <div class="left">
        <ul class="clearfix">
          <li @click="change(8)">
            <div v-if="queryParams['sourceType'] === 8">
              <img src="../../assets/macroscopic/hongguan1.png" alt="">
              <p style="color:#D3131A">宏观</p>
              <em></em>
            </div>
            <div v-else>
              <img class="show" src="../../assets/macroscopic/hongguan.png" alt="">
              <img class="hidden" src="../../assets/macroscopic/hongguan1.png" alt="">
              <p style="color:#222;">宏观</p>
            </div>
          </li>
          <li @click="change(9)">
            <div v-if="queryParams['sourceType'] === 9">
              <img src="../../assets/macroscopic/heise1.png" alt="">
              <p style="color:#D3131A">黑色</p>
              <em></em>
            </div>
            <div v-else>
              <img class="show" src="../../assets/macroscopic/heise.png" alt="">
              <img class="hidden" src="../../assets/macroscopic/heise1.png" alt="">
              <p style="color:#222;">黑色</p>
            </div>
          </li>
          <li @click="change(10)">
            <div v-if="queryParams['sourceType'] === 10">
              <img src="../../assets/macroscopic/huagong1.png" alt="">
              <p style="color:#D3131A">化工</p>
              <em></em>
            </div>
            <div v-else>
              <img class="show" src="../../assets/macroscopic/huagong.png" alt="">
              <img class="hidden" src="../../assets/macroscopic/huagong1.png" alt="">
              <p style="color:#222;">化工</p>
            </div>
          </li>
          <li @click="change(11)">
            <div v-if="queryParams['sourceType'] === 11">
              <img src="../../assets/macroscopic/huanbao1.png" alt="">
              <p style="color:#D3131A">环保</p>
              <em></em>
            </div>
            <div v-else>
              <img class="show" src="../../assets/macroscopic/huanbao.png" alt="">
              <img class="hidden" src="../../assets/macroscopic/huanbao1.png" alt="">
              <p style="color:#222;">环保</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="banner-right-content">
        <ul>
          <li v-for="(item, index) in industryList" :key="index">
            <p v-if="item.newsType===1" @click="goDetail('/macroscopic/industry', item.id,queryParams['sourceType'])">
              <img
                  src="../../assets/macroscopic/left-icon.png" alt="">{{ item.titleName }}
            </p>
            <p v-else @click="openUrl(item)"><img
                src="../../assets/macroscopic/left-icon.png" alt="">{{ item.titleName }}</p>
            <span class="fr">{{ item.showTime }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="bom-head">
      <p>宏观数据</p>
      <ul>
        <li @click="goFirst">
          <div class="show" v-if="firstFlag">
            <p>国民经济</p>
            <img src="../../assets/macroscopic/jingji.png" alt="">
          </div>
          <div class="hidden" v-else>
            <p>国民经济</p>
            <img src="../../assets/macroscopic/jingji1.png" alt="">
            <em></em>
          </div>
        </li>
        <li @click="goTwo">
          <div class="show" v-if="twoFlag">
            <p>房地产</p>
            <img src="../../assets/macroscopic/fangdichan.png" alt="">
          </div>
          <div class="hidden" v-else>
            <p>房地产</p>
            <img src="../../assets/macroscopic/fangdichan1.png" alt="">
            <em></em>
          </div>
        </li>
        <li @click="goThree">
          <div class="show" v-if="threeFlag">
            <p>工业</p>
            <img src="../../assets/macroscopic/gongye.png" alt="">
          </div>
          <div class="hidden" v-else>
            <p>工业</p>
            <img src="../../assets/macroscopic/gongye1.png" alt="">
            <em></em>
          </div>
        </li>
        <li @click="goFour">
          <div class="show" v-if="fourFlag">
            <p>金融</p>
            <img src="../../assets/macroscopic/jinrong.png" alt="">
          </div>
          <div class="hidden" v-else>
            <p>金融</p>
            <img src="../../assets/macroscopic/jinrong1.png" alt="">
            <em></em>
            <span></span>
          </div>
        </li>
      </ul>
    </div>
    <div class="container">
      <Economics class="left-container" v-if="!firstFlag"></Economics>
      <House class="left-container" v-if="!twoFlag"></House>
      <Industry class="left-container" v-if="!threeFlag"></Industry>
      <Finance class="left-container" v-if="!fourFlag"></Finance>
    </div>
  </div>
</template>

<script>
import Economics from "@/components/macroscopic/footerTabs/economics";
import Finance from "@/components/macroscopic/footerTabs/finance";
import House from "@/components/macroscopic/footerTabs/house";
import Industry from "@/components/macroscopic/footerTabs/Industry";
import {industryNoAuthList, industryDetail} from '@/api/macroscopic'

export default {
  name: "index",
  components: {
    Economics,
    House,
    Finance,
    Industry
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 8,
        sourceType: 8
      },
      industryList: [],
      firstFlag: false,
      twoFlag: true,
      threeFlag: true,
      fourFlag: true,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    /**
     * 获取列表
     */
    getList() {
      industryNoAuthList(this.queryParams).then(res => {
        this.industryList = res.rows;
      })
    },
    /**
     * 前往二级页
     */
    toTwoPage(url, flag, num) {
      this.$router.push({path: `${url}`, query: {flag, num}});
    },
    /**
     *  行业动态外链
     */
    openUrl(item) {
      industryDetail(item['id']).then(() => {
        window.openUrl(item.newsContent)
      })
    },
    /**
     * 切换tabs
     */
    change(val) {
      this.queryParams['sourceType'] = val;
      this.getList()
    },
    /**
     * 跳转详情页
     */
    goDetail(url, id, flag) {
      this.$router.push({path: `${url}`, query: {id, flag}})
    },
    /**
     * 点击
     */
    goFirst() {
      this.firstFlag = false;
      this.twoFlag = true;
      this.threeFlag = true;
      this.fourFlag = true;
    },
    goTwo() {
      this.twoFlag = false;
      this.firstFlag = true;
      this.threeFlag = true;
      this.fourFlag = true;
    },
    goThree() {
      this.threeFlag = false;
      this.firstFlag = true;
      this.twoFlag = true;
      this.fourFlag = true;
    },
    goFour() {
      this.fourFlag = false;
      this.firstFlag = true;
      this.twoFlag = true;
      this.threeFlag = true;
    }
  }
}
</script>

<style scoped lang="less">
.macroscopic {
  width: 1200px;
  margin: 0 auto;

  .head {
    color: #222222;
    height: 35px;
    line-height: 30px;
    position: relative;
    border-bottom: 2px solid #ccc;

    i {
      width: 60px;
      height: 2px;
      background: #CCCCCC;
      display: inline-block;
      position: absolute;
      bottom: 0;
    }

    em {
      width: 4px;
      height: 18px;
      background: #D3131A;
      font-style: normal;
      display: inline-block;
      margin-right: 9px;
      vertical-align: middle;
    }

    p {
      font-size: 24px;
      display: inline-block;
      vertical-align: middle;
      width: 96px;
      height: 33px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 33px;
    }

    .unit {
      color: #999999;
      margin-left: 10px;
      display: inline-block;
    }

    span {
      font-size: 12px;
      cursor: pointer;
      color: #222222;
      height: 20px;
      border-bottom: 1px solid #fff;
    }

    span:hover {
      border-bottom: 1px solid #222;
    }
  }

  .banner {
    margin-top: 16px;

    .left {
      width: 243px;
      height: 209px;
      display: inline-block;

      ul {
        li {
          list-style: none;
          width: 120px;
          height: 103px;
          float: left;
          text-align: center;
          cursor: pointer;
          border: 1px solid #DDDDDD;
          position: relative;

          img {
            margin-top: 30px;
            width: 24px;
            height: 24px;
          }

          .hidden {
            display: none;
          }

          em {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 120px;
            height: 6px;
            background: #D3131A;
          }
        }

        li:hover {
          .show {
            display: none;
          }

          .hidden {
            display: inline-block;
          }

          p {
            color: #D3131A !important;
          }
        }

        li:first-child {
          border-right: none;
        }

        li:nth-child(3) {
          border-top: none;
          border-right: none;
        }

        li:last-child {
          border-top: none;
        }
      }
    }

    .banner-right-content {
      display: inline-block;
      width: 936px;
      height: 209px;
      vertical-align: top;
      margin-left: 20px;

      ul {
        li {
          //margin-top: 11px;

          p {
            display: inline-block;
            width: fit-content;
            max-width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;

            img {
              width: 7px;
              margin-right: 7px;
            }
          }

          p:hover {
            color: #D3131A;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            display: inline-block;
            height: 20px;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
          }
        }
      }
    }
  }

  .bom-head {
    margin-top: 30px;

    p {
      width: 96px;
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 33px;
    }

    em {
      position: absolute;
      bottom: 0;
      width: 400px;
      display: block;
      height: 6px;
      background: #D3131A;
    }

    ul {
      margin-top: 16px;

      li {
        display: inline-block;
        position: relative;
        //width: 266px;
        height: 207px;
        cursor: pointer;

        .show {
          width: 266px;
          height: 207px;
          position: relative;
          display: inline-block;

          p {
            position: absolute;
            top: 24px;
            right: 36px;
            color: #fff;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }

        .hidden {
          width: 400px;
          height: 207px;
          position: relative;

          p {
            position: absolute;
            top: 24px;
            left: 36px;
            color: #fff;
          }

          img {
            width: 100%;
            height: 100%;
          }

          span {
            display: inline-block;
            width: 0;
            height: 6px;
            background-color: #D3131A;
          }
        }
      }

      li::after {
        content: '';
        display: block;
        /*开始时候下划线的宽度为0*/
        width: 0;
        height: 6px;
        position: absolute;
        left: 0;
        bottom: 0;
        background: #D3131A;
        /*这里我们设定所有改变都有动画效果，可以自己指定样式才有动画效果*/
        transition: all 0s ease-in-out;
      }

      li:hover::after {
        width: 100%;
        transition: all 0.6s ease-in-out;
      }
    }
  }

  .container {
    margin-top: 25px;
    height: 688px;

    .left-container {
    }
  }
}

</style>
